/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_Ignore_Timecodes_LabelInputs */

const en_plain_text_import_ignore_timecodes_label = /** @type {(inputs: Plain_Text_Import_Ignore_Timecodes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignore Timecodes`)
};

const fr_plain_text_import_ignore_timecodes_label = /** @type {(inputs: Plain_Text_Import_Ignore_Timecodes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignorer les timecodes`)
};

const de_plain_text_import_ignore_timecodes_label = /** @type {(inputs: Plain_Text_Import_Ignore_Timecodes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitcodes ignorieren`)
};

const it_plain_text_import_ignore_timecodes_label = /** @type {(inputs: Plain_Text_Import_Ignore_Timecodes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignora i codici temporali`)
};

const ru_plain_text_import_ignore_timecodes_label = /** @type {(inputs: Plain_Text_Import_Ignore_Timecodes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Игнорировать временные метки`)
};

const es_plain_text_import_ignore_timecodes_label = /** @type {(inputs: Plain_Text_Import_Ignore_Timecodes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignorar códigos de tiempo`)
};

const zh_cn2_plain_text_import_ignore_timecodes_label = /** @type {(inputs: Plain_Text_Import_Ignore_Timecodes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`忽略时间码`)
};

const ja_plain_text_import_ignore_timecodes_label = /** @type {(inputs: Plain_Text_Import_Ignore_Timecodes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイムコードを無視`)
};

const hi_plain_text_import_ignore_timecodes_label = /** @type {(inputs: Plain_Text_Import_Ignore_Timecodes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टाइमकोड को अनदेखा करें`)
};

const pt_pt2_plain_text_import_ignore_timecodes_label = /** @type {(inputs: Plain_Text_Import_Ignore_Timecodes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignorar códigos de tempo`)
};

/**
* | output |
* | --- |
* | "Ignore Timecodes" |
*
* @param {Plain_Text_Import_Ignore_Timecodes_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_ignore_timecodes_label = /** @type {((inputs?: Plain_Text_Import_Ignore_Timecodes_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_Ignore_Timecodes_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_plain_text_import_ignore_timecodes_label(inputs)
	if (locale === "de") return de_plain_text_import_ignore_timecodes_label(inputs)
	if (locale === "it") return it_plain_text_import_ignore_timecodes_label(inputs)
	if (locale === "ru") return ru_plain_text_import_ignore_timecodes_label(inputs)
	if (locale === "es") return es_plain_text_import_ignore_timecodes_label(inputs)
	if (locale === "zh-CN") return zh_cn2_plain_text_import_ignore_timecodes_label(inputs)
	if (locale === "ja") return ja_plain_text_import_ignore_timecodes_label(inputs)
	if (locale === "hi") return hi_plain_text_import_ignore_timecodes_label(inputs)
	if (locale === "pt-PT") return pt_pt2_plain_text_import_ignore_timecodes_label(inputs)
	return en_plain_text_import_ignore_timecodes_label(inputs)
});